<div
  style="position: absolute; top: calc(50% - 64px); left: calc(50% - 268px); transform: translateY(-50%);  margin-left: 12px; background: transparent; border-radius: 6px">



  @if (idp === 'above') {
    <button (click)="login()"
            style="font-size: 64px; line-height: 80px; background-color: #006ea4; border-color:#006ea4; color: white; border-radius: 64px; padding-left: 48px; padding-right: 48px; border: 0; padding-top: 16px ; padding-bottom: 16px ; margin-left: 100px "
    >
      BOARD
    </button>
  }
</div>
@if (idp === 'Castlabs') {
  <div class="cl-main">
    <nav class="cl-nav-top cl-navbar navbar navbar-expand-md">
      <div class="container"><a class="navbar-brand" href="https://castlabs.com/" target="_blank" rel="noopener"><i
        class="cl-asset-logo-eggshell"></i></a><label class="cl-nav-backdrop" for="cl-nav-side"></label>
        <div class="cl-nav-drawer" id="topnav">
          <ul class="navbar-nav me-auto"><p>Making media possible</p></ul>
        </div>
        <label class="cl-nav-side-burger" for="cl-nav-side"><i class="fas fa-bars"></i></label></div>
    </nav>
    <main>
      <div class="cl-app-fullscreen">
        <section class="cl-section">
          <div class="container">
            <div class="row">
              <div class="col-12 text-center"><h2>Content Platform</h2>
                <p>Manage, encode and watermark assets</p></div>
              <div class="col-12 col-lg-3 col-xl-4"></div>
              <div class="col-12 col-lg-6 col-xl-4">
                <div class="card text-center">
                  @if (localDev && !hasEnv) {
                    <form (ngSubmit)="selectEnv()" class="card-body cl-form">
                      <label class="form-label">Dev environment</label>
                      <input type="text" [(ngModel)]="localEnvInput" name="localEnvInput"
                             placeholder="e.g. sannies" autofocus>
                      <p class="valid-feedback">Enter the name of your personal dev environment.</p>
                    </form>
                    <div class="card-footer">
                      <button type="button" class="btn cl-btn-outline-primary"
                              (click)="selectEnv()" [disabled]="!localEnvInput.trim()">
                        <span>Connect</span><i class="fas fa-angle-right"></i>
                      </button>
                    </div>
                  } @else {
                    <div class="card-body"><p>Sign in with your Castlabs account.</p></div>
                    <div class="card-footer"><a class="btn cl-color-red it-signin"
                                                (click)="login()"><span> Sign in </span><i
                      class="fas fa-user"></i></a></div>
                    @if (localDev) {
                      <form (ngSubmit)="selectEnv()" class="card-footer cl-form"
                            style="border-top: 1px solid var(--cl-color-clay)">
                        <label class="form-label">Dev environment</label>
                        <div style="display: flex; gap: 8px; align-items: center">
                          <input type="text" [(ngModel)]="localEnvInput" name="localEnvInput"
                                 placeholder="env name">
                          <button type="submit" class="btn cl-btn-outline-primary"
                                  [disabled]="!localEnvInput.trim()">
                            <span>Switch</span>
                          </button>
                        </div>
                      </form>
                    }
                  }
                </div>
              </div>
              <div class="col-12 col-lg-3 col-xl-4"></div>
            </div>
          </div>
        </section>
      </div>
    </main>
    <app-footer>
    </app-footer>

    <div style="height: 0">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
        <a type="button" class="btn cl-btn-outline-primary cl-btn-icon"
           [href]="'https://above' + basehost + location.pathname + location.hash"
           style="margin: 4px; border: #2a80d599 1px dashed; background-color: transparent; background-size: 150px; background-image: url('../../assets/background-login-above.jpg'); width: 150px; height: 100px"></a>
      </div>
    </div>
  </div>
}


@if (idp === 'above') {
  <div class="cl-main" style="height: 100vh; background-size:
        cover;background-repeat: no-repeat;background-position: center"
       [ngStyle]="{'background-image': 'url(../../assets/background-login-' + idp + '.jpg)'}">
    <main>

    </main>
    <app-footer>
    </app-footer>
    <div style="height: 0">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">

        <a type="button" class="btn cl-btn-outline-primary cl-btn-icon"
           [href]="'https://platform' + basehost + location.pathname + location.hash"
           style="margin: 4px; border: #2a80d599 1px dashed; background-color: transparent; background-size: 150px; background-image: url('../../assets/background-login-Castlabs.png'); width: 150px; height: 100px"></a>

      </div>
    </div>
  </div>
}


@if (idp === 'portal') {
  <div class="cl-main" style="height: 100vh; background-size:
        cover;background-repeat: no-repeat;background-position: center"
       [ngStyle]="{'background-image': 'url(../../assets/background-login-' + idp + '.jpg)'}">
    <main>
    </main>
    <app-footer>
    </app-footer>
    <div style="height: 0">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">

        <a type="button" class="btn cl-btn-outline-primary cl-btn-icon"
           [href]="'https://above' + basehost + location.pathname + location.hash"
           style="margin: 4px; border: #2a80d599 1px dashed; background-color: transparent; background-size: 150px; background-image: url('../../assets/background-login-above.jpg'); width: 150px; height: 100px"></a>
        <a type="button" class="btn cl-btn-outline-primary cl-btn-icon"
           [href]="'https://platform' + basehost + location.pathname + location.hash"
           style="margin: 4px; border: #2a80d599 1px dashed; background-color: transparent; background-size: 150px; background-image: url('../../assets/background-login-Castlabs.png'); width: 150px; height: 100px"></a>

      </div>
    </div>
  </div>
}
